var React = require('react');

function SidebarIconLogout (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.4,7c0.5,0,1,0.2,1.4,0.6l10.6,11c0.8,0.8,0.8,2.1,0,2.9l-10.6,11c-0.4,0.4-0.9,0.6-1.4,0.6s-1-0.2-1.4-0.6\n\t\tc-0.8-0.8-0.8-2.1,0-2.9l7.4-7.6H14c-1.1,0-2-0.8-2-1.9c0-1.1,0.9-2,2-2h21.5L28,10.5c-0.8-0.8-0.8-2.1,0-2.9\n\t\tC28.4,7.2,28.9,7,29.4,7","key":0}),React.createElement("path",{"d":"M21.6,1H2.4C1.1,1,0,2.1,0,3.4v33.1C0,37.9,1.1,39,2.4,39h19.1c1.3,0,2.4-1.1,2.4-2.4v-3V29v-2c0-1.1-0.9-2-2-2\n\t\tc-1.1,0-2,0.9-2,2v2h0v6H4V5h16v5.6V12h0v1c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-1V9.7V6.4v-3C24,2.1,22.9,1,21.6,1z","key":1}),React.createElement("polygon",{"points":"22,25 22,25 22,25","key":2})]);
}

SidebarIconLogout.defaultProps = {"id":"logout-icon","viewBox":"0 0 48 48"};

module.exports = SidebarIconLogout;

SidebarIconLogout.default = SidebarIconLogout;
